import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'

/*---------Live Server----------------*/

window.apiFetchBaseURL = 'https://api.kalima.ai/api/'
window.fileFetchURL = 'https://api.kalima.ai/'

window.campaignBrandImageURL = 'https://b-cdn.kalima.ai/ads/keyword-campaign-icons/'

/*---------Stagging Server----------------*/

// window.apiFetchBaseURL = 'https://api-stag.kalima.ai/api/'
// window.fileFetchURL = 'https://api-stag.kalima.ai/'

/*---------Local----------------*/

// window.apiFetchBaseURL = 'http://127.0.0.1:8000/api/'
// window.fileFetchURL = 'http://127.0.0.1:8000/'

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
